import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from './templates/main.jsx';
import {NAV_CONTEXT} from './constants.js';
import {businessList, list} from './list.js';
import {canUseDOM} from '../../helpers/canUseDOM';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            isMobile: canUseDOM ? window.innerWidth <= 960 : false,
            isTablet: canUseDOM ? window.innerWidth <= 1360 && window.innerWidth > 960 : false,
            isDesktop: canUseDOM ? window.innerWidth > 1360 : true,
            isSearchPage: canUseDOM ? window.location.pathname === '/search' : false
        };

        return this;
    }

    updateWidth = () => {
        if (!canUseDOM) return;
        this.setState({
            isMobile: window.innerWidth <= 960,
            isTablet: window.innerWidth <= 1360 && window.innerWidth > 960,
            isDesktop: window.innerWidth > 1360
        });
    };

    componentDidMount() {
        if (!canUseDOM) return;
        window.addEventListener('resize', this.updateWidth);
        this.unlisten = this.props.history.listen(location => {
            this.setState({isSearchPage: location.pathname === '/search'});
        });
    }

    componentWillUnmount() {
        if (!canUseDOM) return;
        window.removeEventListener('resize', this.updateWidth);
        if (this.unlisten) {
            this.unlisten();
        }
    }

    navigate = (...args) => {
        return this.context.app.navigate(...args);
    };

    isBusiness = () => {
        return this.props.userType === NAV_CONTEXT.BUSINESS;
    };

    homeUrl = () => {
        return this.isBusiness() ? '/business_all' : '/';
    };

    _getActive() {
        if (!this.context.history) return null;
        const pathname = this.context.history.location.pathname;

        if (!this.isBusiness()) {
            const individualMap = {
                cards: [...list.subMenuCards, ...list.subMenuCards2],
                credit: [...list.subMenuCredit, ...list.subMenuCredit2],
                services: [
                    ...list.subMenuServices,
                    ...list.subMenuServices2,
                    ...list.subMenuServices3
                ],
                deposits: [...list.subMenuDeposits, ...list.subMenuDeposits2],
                business: [
                    ...list.subMenuBusiness,
                    ...list.subMenuBusiness2,
                    ...list.subMenuBusiness3
                ],
                contacts: [{url: '/contacts'}],
                branches: [{url: '/branches'}]
            };

            const exactMatch = Object.keys(individualMap).find(key => pathname === `/${key}`);
            if (exactMatch) {
                return exactMatch;
            }

            for (const [alias, submenu] of Object.entries(individualMap)) {
                if (Array.isArray(submenu) && submenu.some(item => item.url === pathname)) {
                    return alias;
                }
            }

            return 'individualDefault';
        }

        const businessMap = {
            businessCalculations: businessList.subMenuBusinessCalculations,
            businessTrade: businessList.subMenuBusinessTrade,
            businessFreeMoney: businessList.subMenuBusinessFreeMoney,
            businessFinancing: businessList.subMenuBusinessFinancing,
            businessGov: businessList.subMenuBusinessGov,
            businessABusiness: [{url: '/business/abusiness'}]
        };

        for (const [alias, submenu] of Object.entries(businessMap)) {
            if (Array.isArray(submenu) && submenu.some(item => item.url === pathname)) {
                return alias;
            }
        }

        return 'businessDefault';
    }

    _getSubActive() {
        if (!this.context.history) return null;
        const {pathname, search, hash} = this.context.history.location;

        return search || hash ? pathname + (search || '') + (hash || '') : pathname;
    }

    static displayName = 'Header';

    static contextTypes = {
        app: PropTypes.object,
        history: PropTypes.object
    };
}
